import React from "react";
import Routes from "./routes";

export default () => {
  return <Routes />;
};
